import axios from 'axios';
import config from '../config/api.json';
const { API_URL, API_VERSION, API_KEY } = config;

function normalizeStringForUrl(str) {
  if (typeof str !== "string") return "";
  return str.replace(/\//g, "%2F").replace(/,/g, "%82").replace(/;/g, "%3B").replace(/:/g, "%3A").replace(/=/g, "%3D").replace(/ /g, "%20");
}

export const getCertificates = async () => {
  try {
    const response = await axios.get(`${API_URL}/${API_VERSION}/getCertificates`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response.data;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const renewCertificate = async (domain) => {
  try {
    const response = await axios.get(`${API_URL}/${API_VERSION}/renewCertificate?certificate=${domain}`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response.data;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getOrders = async () => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Order/id,num,date/path:Droppix%2FOrders/num:DESC/100000:0/totalCount:1`, {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getOrderItems = async (orderNUM) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/OrderItem/id,description,quantity,price,percent,trackingLink,trackingNumber/path:Droppix%2FOrders%2F${orderNUM}/description:ASC/100000:0/totalCount:1`, {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });
    console.log("Order items response:", response.data.data.getOrderItemListing.edges);
    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const deleteOrder = async (orderID) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/delete/Order/${orderID}`, {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addOrder = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/create/Order/27524/${data.num}/num:${data.num};date:${data.date}`, {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addOrderItem = async (data) => {
  const timestamp = Date.now();
  const normalizedData = { ...data };
  Object.keys(normalizedData).forEach(key => {
    if (typeof normalizedData[key] === 'string') {
      normalizedData[key] = normalizeStringForUrl(normalizedData[key]);
    }
  });
  data = normalizedData;
  console.log("Adding order item with data:", data);
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/create/OrderItem/${data.id}/${timestamp}/description:${data.description};quantity:${data.quantity};price:${data.price};trackingNumber:${data.trackingNumber};trackingLink:${data.trackingLink};delivered:${data.delivered};collected:${data.collected};percent:${data.percent}`, {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const updateOrder = async (data) => {
  console.log("Updating order with data:", data);
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/Order/${data.id}/num:${data.num};date:${data.date}`, {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const sendmail = async (formdata) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/sendmail`, formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response.data;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const getFiles = async (path = "/files") => {
  try {
    const response = await axios.get(`${API_URL}/${API_VERSION}/getFiles?p=${path}/`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const getPDF = async () => {
  try {
    const response = await axios.get(`${API_URL}/${API_VERSION}/getPDF`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      responseType: 'blob',
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const scan = async (formdata) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/scan`, formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response.data;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const register = async (username, password) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/register`, { username, password }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response.data;
};

export const login = async (username, password, otp) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/login`, { username, password }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });

  return await verify2fa(username, otp) ? response.data : null;
};

export const get2fa = async (appname, username) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/2fa/get`, { appname, username }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response;
};

export const verify2fa = async (username, otp) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/2fa/verify`, { username, otp }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response.status === 200 ? true : console.log("2FA verification failed:", response);
};

export const getOnedrive = async (master, path, filename = "") => {
  try {
    const response = await axios.get(`${API_URL}/${API_VERSION}/onedrive/get/${master}/${path}/${filename}`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const createOnedrive = async (master, path, foldername) => {
  console.log(`Creating folder "${foldername}" in path "${path}" for master "${master}"`);
  try {
    const response = await axios.get(`${API_URL}/${API_VERSION}/onedrive/create/${master}/${path}/${foldername}`, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};